// extracted by mini-css-extract-plugin
module.exports = {"highlightedFeature":"page_highlightedFeature__3cV4G"};